import React from "react"
import { Link } from "react-router-dom"
import { Nav, NavItem } from "reactstrap"
import classnames from "classnames"
import PropTypes from "prop-types"
import { getEntityTypeMapping } from "../../helpers/sharedHelperFunctions"
import { SECONDARY_NAV_TABS } from "../../helpers/sharedConstants"
import "./SecondaryNav.scss"

const SecondaryNav = props => (
  <div className="SecondaryNav">
    <Nav>
      {SECONDARY_NAV_TABS[
        getEntityTypeMapping(props.entityType).singularField
      ].map(tab => {
        if (props.disabledLinks && props.disabledLinks.includes(tab.key)) {
          return (
            <div key={tab.key} className="inactive-tab">
              {tab.label}
            </div>
          )
        } else {
          return (
            <NavItem key={tab.key}>
              <Link
                key={tab.key}
                to={tab.url}
                className={classnames({
                  "nav-link": true,
                  active: props.activeTab === tab.key,
                })}
              >
                {tab.label}
              </Link>
            </NavItem>
          )
        }
      })}
    </Nav>
  </div>
)

SecondaryNav.propTypes = {
  entityType: PropTypes.string.isRequired,
  activeTab: PropTypes.string.isRequired,
  disabledLinks: PropTypes.arrayOf(PropTypes.string.isRequired),
}

export default SecondaryNav
